import { configureStore } from "@reduxjs/toolkit";
import { menuAuthReducer } from "./menuAuthReducer";
import { multiLangReducer } from "./multiLangReducer";

// 상태 로드 함수 (세션 스토리지에서 가져오기)
const loadState = (key) => {
  try {
    const serializedState = sessionStorage.getItem(key);
    sessionStorage.removeItem(key);
    return serializedState ? JSON.parse(serializedState) : undefined;
  } catch (err) {
    return undefined;
  }
};

// 상태 저장 함수 (세션 스토리지에 저장)
const saveState = (state, key) => {
  try {
    const serializedState = JSON.stringify(state);
    sessionStorage.setItem(key, serializedState);
  } catch (err) {}
};

// 초기 상태 설정
const preloadedState = {
  menuAuth: loadState("menuAuthInfo"),
  multiLang: loadState("multiLangInfo"),
};

// 브라우저 새로고침 전에 상태를 세션 스토리지에 저장
window.addEventListener("beforeunload", () => {
  saveState(store.getState().menuAuth, "menuAuthInfo");
  saveState(store.getState().multiLang, "multiLangInfo");
});

const store = configureStore({
  reducer: {
    menuAuth: menuAuthReducer,
    multiLang: multiLangReducer,
  },
  preloadedState,
});

export default store;
